export default function PromoPage() {
  return (
    <div className='max-w-[85rem] mx-auto'>
      <h2 className='text-white bg-primary py-4 px-8 rounded-t-lg text-xl font-semibold'>
        Program Booster Promotional Campaign
      </h2>
      <div className='p-8 border border-gray-300 rounded-b-lg shadow-md'>
        <section className='mb-8'>
          <h2 className='text-2xl font-bold mb-4 text-gray-800'>
            Boost Your Program, Get Rewarded for Every New Member, & Reach Your
            Goals Faster!
          </h2>
          <p className='mb-3 text-gray-700 leading-relaxed'>
            <strong>Starting June 1, 2025</strong>, we’re excited to launch an
            exclusive limited-time promotion to supercharge your growth!
          </p>
          <p className='text-gray-700 leading-relaxed'>
            Earn $1 for every new qualifying* member who signs up to your
            program and enrolls a card within 30 days –{' '}
            <strong>NO LIMITS!</strong>
          </p>
        </section>

        <div className='border-t border-gray-200 my-8'></div>

        <section className='mb-8'>
          <h3 className='text-xl font-semibold mb-4 text-gray-800'>
            Here’s How It Works:
          </h3>
          <ul className='list-disc pl-6 space-y-3 text-gray-700'>
            <li className='leading-relaxed'>
              ✅ New unique member must sign up and enroll a card within 30 days
              from signing up to your program.
            </li>
            <li className='leading-relaxed'>
              ✅ Rewards are posted in your Partner Portal in real time
            </li>
            <li className='leading-relaxed'>
              ✅ Promotion reward will be paid by the{' '}
              <strong>15th of each month</strong> for the qualified members that
              signed up in the <strong>previous calendar month</strong>, with a
              minimum payout of $25.
            </li>
            <li className='leading-relaxed'>
              ✅ No cap — the more qualified sign-ups, the more you earn!
            </li>
          </ul>
        </section>

        <div className='border-t border-gray-200 my-8'></div>

        <section className='mb-8'>
          <h3 className='text-xl font-semibold mb-3 text-gray-800'>
            Promotion Period:
          </h3>
          <p className='mb-3 text-gray-700 leading-relaxed'>
            <strong>June 1, 2025 – September 30, 2025</strong>
          </p>
          <p className='text-gray-700 leading-relaxed'>
            This is your chance to ramp up engagement and maximize rewards.
            Let’s grow your program together!
          </p>
        </section>

        <div className='border-t border-gray-200 my-8'></div>

        <section className='mb-8'>
          <h3 className='text-xl font-semibold mb-4 text-gray-800'>Terms:</h3>
          <ul className='list-disc pl-6 space-y-3 text-gray-700'>
            <li>
              Members who enrolled prior to the promotion start date are not
              eligible for the reward.
            </li>
            <li>
              In the <strong>Partner Portal – Promotion</strong> section, you
              can view a list of signed-up members sorted by:
              <ul className='list-disc pl-6 mt-2 space-y-2'>
                <li>Sign-up date</li>
                <li>Number of enrolled cards</li>
                <li>Date of the first card’s enrollment</li>
                <li>
                  Reward status:
                  <ul className='list-disc pl-6 mt-2 space-y-2'>
                    <li>
                      <strong>Earned</strong> – The member has met the
                      qualifying criteria.
                    </li>
                    <li>
                      <strong>Pending</strong> – The member is still within the
                      30-day period and has not yet enrolled a card.
                    </li>
                    <li>
                      <strong>Didn’t Qualify</strong> – No card was enrolled
                      within the 30-day qualifying period.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>Members have to be unique and new to Savers App.</li>
            <li>Only one (1) sign-up per member is allowed.</li>
            <li>
              It’s $1 per signed-up member, regardless of the number of cards
              that member enrolls.
            </li>
            <li>
              Members who sign up during the promotion period must download the
              app and upload at least one (1) card within 30 days of registering
              in your program. If cards are enrolled after 30 days, sign-up will
              not qualify for the reward.
            </li>
          </ul>

          <div className='mt-6'>
            <p className='font-semibold mb-3 text-gray-800'>
              <strong>Examples:</strong>
            </p>
            <ul className='list-disc pl-6 space-y-3 text-gray-700'>
              <li>
                <strong>Example 1:</strong> A member downloads the app and signs
                up to your program on June 28, then enrolls a card on July 7.
                They qualify for the reward in July, and the reward will be paid
                out on August 15.
              </li>
              <li>
                <strong>Example 2:</strong> A member downloads the app and signs
                up to your program on June 28, then enrolls a card on July 31.
                They do not qualify for the reward, as the card enrollment
                occurred more than 30 days after signing up.
              </li>
              <li>
                <strong>Example 3:</strong> A member downloads the app, signs up
                to your program, and enrolls a card on June 28. They qualify for
                the reward in June, and the reward will be paid on July 15.
              </li>
            </ul>
          </div>
        </section>

        <div className='border-t border-gray-200 my-8'></div>

        <section className='mb-8'>
          <h3 className='text-xl font-semibold mb-4 text-gray-800'>
            Reward Eligibility
          </h3>
          <p className='mb-3 text-gray-700 leading-relaxed'>
            Savers App reserves the right to review, withhold, or revoke any
            rewards granted as part of this campaign if it determines, at its
            sole discretion, that an enrollment was not made in good faith.
            Rewards are intended to incentivize genuine user participation in
            the program and legitimate engagement with its card-linked offers.
            Enrollments that appear to be made solely for the purpose of
            manipulating or maximizing rewards – rather than to genuinely join
            and benefit from the program – may be deemed invalid.
          </p>
          <ul className='list-disc pl-6 space-y-2 text-gray-700'>
            <li>
              Self-referrals or creating multiple accounts by the same
              individual
            </li>
            <li>Referrals of fictitious or non-genuine people</li>
            <li>Coordinated or automated enrollments</li>
            <li>Enrollments followed by immediate account deletions</li>
            <li>
              Any pattern of behavior that circumvents the intent of the
              campaign
            </li>
          </ul>
          <p className='mt-3 text-gray-700 leading-relaxed'>
            Savers App reserves the right to audit any account or referral
            activity and may, at its sole discretion, disqualify participants,
            reverse rewards, or take further action as necessary to uphold the
            integrity of the promotion. All enrollments must comply with Savers
            App’s terms of use and the specific terms of this promotion.
            Fraudulent or suspicious activity will result in forfeiture of all
            associated rewards and may lead to permanent exclusion from future
            promotions.
          </p>
        </section>

        <div className='border-t border-gray-200 my-8'></div>

        <p className='text-gray-700 leading-relaxed'>
          If you have any questions about the promotion, please submit a ticket
          to{' '}
          <a
            href='mailto:programs@saversapp.com'
            className='text-blue-600 hover:text-blue-800 underline'
          >
            programs@saversapp.com
          </a>{' '}
          – we’re here to support and happy to help!
        </p>
      </div>
    </div>
  );
}
